/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MigrateToS3Result
 */
export interface MigrateToS3Result {
    /**
     * 
     * @type {string}
     * @memberof MigrateToS3Result
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof MigrateToS3Result
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MigrateToS3Result
     */
    'status': MigrateToS3ResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MigrateToS3Result
     */
    'storageId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MigrateToS3ResultStatusEnum {
    Ok = 'OK',
    Error = 'ERROR',
    Warn = 'WARN'
}


